import { render, staticRenderFns } from "./AddSubGroup.vue?vue&type=template&id=41e0378e&scoped=true&"
import script from "./AddSubGroup.vue?vue&type=script&lang=js&"
export * from "./AddSubGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e0378e",
  null
  
)

export default component.exports